import {Component, Input} from '@angular/core';
import {PrescriptionErrorFields} from '@drl/shared/models/csv-upload-report.model';

@Component({
  selector: 'app-prescriptions-report',
  templateUrl: './prescriptions-report.component.html',
  styleUrls: [],
})
export class PrescriptionsReportComponent {
  @Input() prescriptionsErrors: PrescriptionErrorFields[];
}
